module.exports = __webpack_public_path__ + "static/media/ElongedInactive.1cf56f6c.svg";